import React, { createContext, useContext } from 'react';

const DslConfigOwnerContext = createContext<string | undefined>(undefined);

export interface DslConfigOwnerProviderProps {
  /** The `tenantId` that owns the DSL config being rendered. */
  readonly tenantId: string | undefined;
  readonly children: React.ReactNode;
}

export function DslConfigOwnerProvider({
  tenantId,
  children,
}: DslConfigOwnerProviderProps): React.ReactElement {
  return (
    <DslConfigOwnerContext.Provider value={tenantId}>
      {children}
    </DslConfigOwnerContext.Provider>
  );
}

/** `undefined` outside a `DslConfig` render or when the payload has no owner. */
export function useDslConfigOwnerTenantId(): string | undefined {
  return useContext(DslConfigOwnerContext);
}
